import { createAsyncActionType } from './index';

export const NEWS_LIST_GET = createAsyncActionType('news', 'NEWS_LIST_GET');

export const NEWS_DETAILS_GET = createAsyncActionType(
  'news',
  'NEWS_DETAILS_GET'
);

export const NEWS_DETAILS_RESET = '@@news/NEWS_DETAILS_RESET';
